// Module
var code = "<div class=\"rb-element rb-break rb-edit no-drag clearfix\" ng-model=\"element\" translate=\"rubric-element_end-category\"></div>";
// Exports
module.exports = code;